export enum ExtensionType {
	Barrier = 'barrier',
	Branding = 'branding',
	Rails = 'rails',
	Rounding = 'rounding',
	Availability = 'availability',
	Hangers = 'hangers',
	Mesh = 'mesh'
}

export class Extension<Type> {
	readonly type: ExtensionType;
	active: boolean;
	params: Type;

	constructor(type: ExtensionType, active: boolean, params: Type) {
		this.type = type;
		this.active = active;
		this.params = structuredClone(params);
	}

	copy() {
		return new Extension(this.type, this.active, this.params);
	}
}
